<template>
  <div class="column col items-center window-width">
    <BreadcrumbPageHeader :breadcrumbs="breadcrumbs" title="Requests">
      <QTabs
        :value="approvalStatus"
        align="left"
        inline-label
        class="no-border-radius"
        active-color="primary"
        @input="$emit('update:approval-status', $event)"
      >
        <SAITab
          v-for="tab in approvalStatuses"
          :key="tab.value"
          :name="tab.value"
          :label="tab.label"
          :disable="loading"
          indicatorHeight="2px"
          show-inactive-indicator
          class="rounded-borders"
          content-class="q-py-sm q-px-md"
        />
      </QTabs>
    </BreadcrumbPageHeader>
    <div class="bg-white col full-width">
      <div class="desktop-single-column q-pa-md">
        <div class="row items-center q-mb-md">
          <span class="text-paragraph text-weight-medium q-ml-md">
            {{ total }} Requests
          </span>
          <QSeparator vertical class="q-mx-lg" color="grey-4" />
          <QInput
            class="search-input col q-mr-sm"
            :value="filter"
            outlined
            dense
            placeholder="Search by keyword or number"
            @input="$emit('update:filter', $event)"
          >
            <template v-slot:append>
              <QIcon name="eva-search-outline" color="primary" />
            </template>
          </QInput>

          <SAICardToggle
            v-for="type in approvalTypes"
            :key="type.value"
            background="white"
            active-background="primary-light"
            height="40px"
            class="q-ml-sm q-px-md row items-center"
            :active="approvalType === type.value"
            @click="$emit('update:approval-type', type.value)"
          >
            <span class="text-weight-medium">{{ type.label }}</span>
          </SAICardToggle>
        </div>
        <QTable
          flat
          :columns="columns"
          :data="approvals"
          :loading="loading"
          :filter="filter"
          :pagination="pagination"
          table-header-class="bg-grey-2"
          @update:pagination="$emit('update:pagination', $event)"
          @row-click="selectApplication"
        />
        <QSpace />
      </div>
    </div>
  </div>
</template>

<script>
import { QTable, QTabs, QInput, QIcon, QSpace, QSeparator } from 'quasar';
import { SAITab, SAICardToggle } from 'ecx.saigon.ui.common';
import { DEFAULT_PAGINATION } from '../../../utils/constants';

export default {
  name: 'HRApprovals',
  props: {
    loading: Boolean,
    filter: String,
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    approvalStatus: {
      type: String,
      required: true
    },
    approvalStatuses: {
      type: Array,
      default: () => []
    },
    approvalType: String,
    approvalTypes: {
      type: Array,
      default: () => []
    },
    approvals: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: DEFAULT_PAGINATION.page
    },
    size: {
      type: Number,
      default: DEFAULT_PAGINATION.size
    },
    columns: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    selectApplication(evt, row) {
      this.$emit('select:application', row);
    }
  },
  components: {
    QTable,
    QTabs,
    SAITab,
    QInput,
    QIcon,
    QSpace,
    SAICardToggle,
    QSeparator,
    BreadcrumbPageHeader: () => import('../../molecule/breadcrumb-page-header')
  }
};
</script>

<style lang="sass" scoped>
.search-input::v-deep
  max-width: 328px

  .q-field__append
    opacity: 1
</style>
